import React, { Suspense } from 'react'
import { styled } from '@mui/material/styles'
import { useRouter } from 'next/router'
import { Container, Box } from '@mui/material'
import { StyledDiv } from '@components/atoms/StyledDiv'
import { BackdropCircularProgress } from '@components/organisms/BackdropCircularProgress'
import { CatalogCategoryBreadcrumbs } from '@components/organisms/CatalogCategoryBreadcrumbs'
import { useGetCatalogQuery } from '@services/cloud/client'
import { CatalogView } from './CatalogView'
import { CompanyInfoView } from './CompanyInfoView'
import { RelateCatalogs } from './RelateCatalogs'

const PREFIX = 'Catalog'

const classes = {
  container: `${PREFIX}-container`,
  feedContainer: `${PREFIX}-feedContainer`,
}

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')(({ theme }) => ({
  [`& .${classes.container}`]: {
    marginBottom: theme.spacing(1),
    minHeight: '80vh',
  },

  [`& .${classes.feedContainer}`]: {
    marginTop: theme.spacing(3),
  },
}))

export function Catalog() {
  const router = useRouter()
  const { catalogId, companyId } = router.query

  const { data, error, loading } = useGetCatalogQuery({
    variables: {
      args: {
        catalogId: catalogId as string,
        companyId: companyId as string,
      },
    },
  })

  if (error) {
    return <div>404 ページが存在しません</div>
  }

  if (loading) {
    return null
  }

  if (!data || !data.catalog) {
    return <div>404 ページが存在しません</div>
  }

  const thumbnails = Array.isArray(data.catalog.thumbnailUrls)
    ? data.catalog.thumbnailUrls.map((thumbnailUrl) => ({
        url: String(thumbnailUrl?.url),
      }))
    : [{ url: 'https://coataz.s3-ap-northeast-1.amazonaws.com/thumb.png' }]

  return (
    <Root>
      <Container className={classes.container} maxWidth="md">
        <StyledDiv>
          <Box mt={1}>
            {data?.catalog?.category?.firstDepth?.categoryId && (
              <CatalogCategoryBreadcrumbs category={data.catalog.category} />
            )}
          </Box>
          <Suspense fallback={<div />}>
            <CatalogView catalog={data.catalog} thumbnails={thumbnails} />
            <CompanyInfoView catalog={data.catalog} />
            <Box pt={1}>
              <RelateCatalogs catalog={data.catalog} />
            </Box>
          </Suspense>
        </StyledDiv>
      </Container>
      <BackdropCircularProgress />
    </Root>
  )
}

export default Catalog
